import { useGraphObject } from '@squareup/dex-feature-hooks-graph';
import { ReferenceObject } from '@squareup/dex-tech-reference-properties';
import { ReferenceHrefBuilders, toUrl } from '@squareup/dex-tech-utils-routing';
import { HeadWrapper } from '@squareup/dex-ui';
import { ContentLayoutGrid } from '@squareup/dex-ui-shared-content-layout-grid';
import {
  getNextPublicApiReferenceNameOrDefault,
  getNextPublicSquareDocsURL,
} from '@squareup/dex-utils-environment';
import { useParams } from '@squareup/dex-utils-shared-routing-hooks';
import React, { ReactNode, useMemo } from 'react';

import { SquareVersionPage } from '../../../../shared/SquareVersionPage';

const PageContent = () => {
  const query = useParams();
  const { object } = useGraphObject();

  const square_version = query?.square_version as string;

  const backHref = useMemo(() => {
    return ReferenceHrefBuilders.versionObjects({
      square_version,
    });
  }, [square_version]);

  if (!object) {
    return null;
  }

  const description = object.summary ?? '';
  const title = `${
    object.name
  } Object - ${getNextPublicApiReferenceNameOrDefault()}`;

  return (
    <>
      <HeadWrapper
        description={description}
        preconnectUrl={getNextPublicSquareDocsURL()}
        title={title}
        canonicalPath={toUrl(
          ReferenceHrefBuilders.versionObject({
            square_version,
            object: object.name,
          })
        )}
      />
      <ContentLayoutGrid singleColumn={true}>
        <section>
          <ReferenceObject
            entity={object}
            eyebrow="Object"
            showVersionSwitcher={true}
            backHref={backHref}
          ></ReferenceObject>
        </section>
      </ContentLayoutGrid>
    </>
  );
};

class Page extends SquareVersionPage {
  public static override routeHandlerName = '[square_version]/objects/[object]';

  protected override getPageContent(): ReactNode {
    return super.getPageContent({
      children: <PageContent />,
    });
  }
}

export default Page;
